const $ = require('jquery');
import {setElementsFromScope, insertTextAndClean} from "../../utilities/selectorHelpers";
import render from "../../utilities/render";
import run from "../../utilities/run";
import {createPreventDefault} from '../../utilities/general';

const elementsMap = {
  mainToggleContainer: ".we-main-toggle-container",
  mainToggleBtn: ".we-main-toggle-btn"
};

export default function weToggleHandler(options={}){
  const self = this;
  const els = {};
  self.init = function(){
    setElements();
    bindElements();
  }

  // self.onViewToggleCallback = function(){
  //   // NOTE: for upcoming story, will implement later
  // }

  function setElements(){
    setElementsFromScope(els, elementsMap, options.mainEl);
  }

  function bindElements(){
    els.mainToggleBtn.click(handleSettingActive);
  }

  function handleSettingActive(e){
    e.preventDefault();
    const btnClicked = $(this);

    if(btnClicked.hasClass("disabled")){
      return;
    }

    els.mainToggleBtn.removeClass("active");
    btnClicked.addClass("active");
  }



}



// WEBPACK FOOTER //
// ./src/components/WidgetEngine/weToggleHandler.js